import { render, staticRenderFns } from "./email.vue?vue&type=template&id=0046ac4b&scoped=true&lang=pug&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"
import style0 from "./email.vue?vue&type=style&index=0&id=0046ac4b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046ac4b",
  null
  
)

export default component.exports